import { createStyles, makeStyles, Slider, withStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {},
  }),
);

export const SliderStyled = withStyles({
  root: {
    height: 0,
    padding: '0px !important',
    marginBottom: '15px',
  },
  thumb: {
    height: 28,
    width: 28,
    marginTop: -6,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 16,
    borderRadius: 8,
  },
  rail: {
    height: 16,
    borderRadius: 8,
  },
})(Slider);
